/**
 * DOM adapter: pointer-move / pointer-up. Translates the pointer event into
 * stage-relative screen + model points and hands them to the gesture engine.
 */

import { type EditorMutableState, endDrag, moveDrag } from '@kaiizen/kai-floor-plan-editor-core';
import { pointerScreenPoint, screenToModelPoint } from './domPoint';

export function handlePointerMove(
  e: PointerEvent,
  st: EditorMutableState,
  svgEl: SVGSVGElement,
  render: () => void,
): void {
  if (!st.drag) return;
  moveDrag(st, pointerScreenPoint(svgEl, e), screenToModelPoint(st.viewport, svgEl, e));
  render();
}

export function handlePointerUp(st: EditorMutableState, render: () => void): void {
  if (!st.drag) return;
  endDrag(st);
  render();
}
